import React, { useEffect, useState } from "react";
import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack, BiPrinter, BiX, BiLoader, BiFile, BiImage, BiCheckCircle, BiXCircle } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Skeltons from "../../../components/loading/Skeltons";
import { Currency, Top } from "../purchase-requisition/configuration";
import DatePicker from "react-datepicker";
import { ChangeToString } from "../../../components/form/ObjectChanger";
import { getObjectIdsByPRListID } from "../../../components/tools/PCGetter";
import { toast } from "react-toastify";

const ConfirmModal = ({ show, onConfirm, onCancel, type, reason, onReasonChange }) => {
  if (!show) return null;
  const isApprove = type === "approve";
  const reasonEmpty = !isApprove && !(reason || "").trim();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-sm mx-4">
        <div className={`flex items-center gap-3 mb-4 ${isApprove ? "text-green-600" : "text-red-500"}`}>
          {isApprove ? <BiCheckCircle className="text-3xl" /> : <BiXCircle className="text-3xl" />}
          <h3 className="text-lg font-semibold text-gray-800">
            {isApprove ? "Konfirmasi Approve" : "Konfirmasi Tolak"}
          </h3>
        </div>
        <p className="text-gray-600 mb-4 text-sm">
          {isApprove
            ? "Apakah Anda yakin ingin menyetujui Price Comparison ini?"
            : "Apakah Anda yakin ingin menolak Price Comparison ini?"}
        </p>
        {!isApprove && (
          <div className="mb-6">
            <label className="block text-xs font-semibold text-gray-600 mb-1">
              Alasan penolakan <span className="text-red-500">*</span>
            </label>
            <textarea
              value={reason || ""}
              onChange={(e) => onReasonChange(e.target.value)}
              rows={3}
              placeholder="Tuliskan alasan penolakan agar pemohon mengetahuinya…"
              className="w-full text-sm border border-gray-300 rounded-lg p-2 outline-none focus:border-red-400 resize-none"
            />
          </div>
        )}
        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
          >
            Batal
          </button>
          <button
            onClick={onConfirm}
            disabled={reasonEmpty}
            className={`px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors ${
              isApprove ? "bg-green-500 hover:bg-green-600" : "bg-red-500 hover:bg-red-600"
            } ${reasonEmpty ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            {isApprove ? "Ya, Approve" : "Ya, Tolak"}
          </button>
        </div>
      </div>
    </div>
  );
};

const ApprovalPurchaseComparationPage = ({}) => {
  let initialState = {
    SupplierCount: 0,
    BisnisUnitID: "U0002",
  };

  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
  ];

  const { values, touched, customHandler, changeHandler, errors } = useForm(
    initialState,
    validations
  );

  const [buttonTouched, setButtonTouched] = useState(false);
  const [confirmModal, setConfirmModal] = useState({ show: false, type: null });
  const [rejectReason, setRejectReason] = useState("");
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [prData, setPRData] = useState([]);
  const [barang, setBarang] = useState([]);
  const [pRListComparison, setPRListComparison] = useState([]);
  const [showDetail, setshowDetail] = useState(true);
  const [generalTotal, setGeneralTotal] = useState(0);
  const [isJasa, setisJasa] = useState(false);
  const [Termin1, setTermin1] = useState("");
  const [Termin2, setTermin2] = useState("");
  const [Termin3, setTermin3] = useState("");
  const supplier = useMutation((formData) => fetchGet("Master/Supplier/min"));
  const barangDetail = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [supplierSelected, setSupplierSelected] = useState(1);
  const [fileViewer, setFileViewer] = useState({
    open: false,
    url: null,
    type: null, // "pdf" | "image"
    name: "",
    loading: false,
    error: false,
  });

  // ── Term of Payment / Cash (tingkat dokumen) ────────────────────────────────
  // Approver perlu tahu SEBELUM menekan Setuju: menyetujui dokumen ber-TOP Cash pada
  // level FINAL akan otomatis MEMBENTUK dokumen uang muka (CashJournal 'Downpayment PO')
  // sebesar Grand Total — lihat createDownpaymentFromCashPC di PriceComparison.go.
  // Sebelumnya keterangan ini cuma ada sebagai satu opsi di dropdown Term of Payment
  // per-supplier, terkubur di dalam tab, dan tak menyebut konsekuensinya sama sekali.
  //
  // Aturannya direplika PERSIS dari backend: kandidat = supplier ber-TOP "0" yang punya
  // minimal satu item terpilih (PilihanBeli), nominal = Grand Total TERENDAH di antaranya.
  // Karena PilihanBeli di halaman ini masih bisa diubah approver, angkanya ikut bergerak
  // mengikuti pilihan yang sedang dibuat.
  const isCashMode = (pRListComparison || []).some(
    (sp) => sp && String(sp["TOP"]) === "0"
  );

  const cashDownpaymentAmount = (() => {
    const kandidat = (pRListComparison || [])
      .filter(
        (sp) =>
          sp &&
          String(sp["TOP"]) === "0" &&
          (sp["PRListComparison"] || []).some(
            (it) =>
              it && (it["PilihanBeli"] === true || it["PilihanBeli"] === "true")
          )
      )
      .map((sp) => parseFloat(sp["GTOTAL"] || 0) || 0)
      .filter((v) => v > 0);
    return kandidat.length ? Math.min(...kandidat) : 0;
  })();

  // Cadangan saat approver belum mencentang apa pun — abaikan PilihanBeli supaya
  // nominalnya tetap terbaca, bukan menampilkan Rp 0 yang menyesatkan.
  const cashDownpaymentEstimasi = (() => {
    const kandidat = (pRListComparison || [])
      .filter((sp) => sp && String(sp["TOP"]) === "0")
      .map((sp) => parseFloat(sp["GTOTAL"] || 0) || 0)
      .filter((v) => v > 0);
    return kandidat.length ? Math.min(...kandidat) : 0;
  })();

  const adaTopTerisi = (pRListComparison || []).some(
    (sp) => sp && String(sp["TOP"] || "") !== ""
  );

  // Label termin yang benar-benar dipakai di dokumen ini. "Term of Payment" saja tidak
  // cukup buat approver — 7 hari dan 90 hari konsekuensi kasnya jauh berbeda.
  const topLabels = Array.from(
    new Set(
      (pRListComparison || [])
        .map((sp) => (sp ? String(sp["TOP"] || "") : ""))
        .filter((v) => v !== "" && v !== "0")
    )
  )
    .sort((a, b) => Number(a) - Number(b))
    .map((v) => (Top.find((t) => t.value === v) || {}).label || v + " Hari");

  // Dokumen campuran: sebagian supplier Cash, sebagian bertermin. Backend tetap
  // membentuk uang muka, tapi approver perlu tahu ini bukan Cash seluruhnya.
  const isCampuran = isCashMode && topLabels.length > 0;

  const ModalOpener = (detail) => {
    setShowModal(true);
  };

  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/PriceComparison/approval/send", formData)
  );

  const mutationSave = useMutation((formData) =>
    fetchPut("Procurement/UpdateCheckedPriceComparison", formData)
  );

  const PurchaseRequisition = useMutation((formData) =>
    fetchPost("Procurement/PurchaseRequisition/min", formData)
  );

  const PurchaseRequisitionDetail = useMutation((formData) =>
    fetchGet("Procurement/PurchaseRequisitionStockOnly/" + formData)
  );

  const franco = useMutation((formData) => fetchGet("Master/Franco/min"));

  const PriceComparison = useMutation((formData) =>
    fetchGet("Procurement/PriceComparison/" + formData)
  );

  const priceComparison = useMutation((formData) =>
    fetchGet("Procurement/PriceComparisonFromPRID/" + formData)
  );

  const param = useLocation();
  const mutationUpdate = useMutation((formData) =>
    fetchPost("Procurement/PriceComparison/approval/update", formData)
  );

  const navigate = useNavigate();

  // Fungsi untuk menghitung ulang summary per supplier
  // Fungsi untuk menghitung ulang summary per supplier dengan default checkbox
  const calculateSupplierSummary = (
    supplierData,
    supplierIndex = 0,
    allSuppliers = []
  ) => {
    if (!supplierData || !supplierData.PRListComparison) return supplierData;

    let totalHargaChecked = 0;
    let totalItemDiscount = 0;

    // Jika ini adalah supplier pertama (index 0), set semua checkbox ke true
    const updatedPRList = supplierData.PRListComparison.map((item) => {
      const harga = parseFloat(item["Harga"] || 0);
      const qty = parseFloat(item["Qty"] || 0);
      const totalBeforeDiscount = harga * qty;

      // Hitung diskon per item
      let itemDiscount = 0;
      const discountPercent = parseFloat(item["DiscountPercent"] || 0);
      const discountRupiah = parseFloat(item["DiscountRupiah"] || 0);

      if (discountPercent > 0) {
        itemDiscount = (totalBeforeDiscount * discountPercent) / 100;
      } else if (discountRupiah > 0) {
        itemDiscount = discountRupiah;
      }

      const totalAfterItemDiscount = totalBeforeDiscount - itemDiscount;

      // Default: supplier pertama (index 0) semua item tercentang
      // Untuk supplier lain, cek apakah item dengan BarangID yang sama sudah dicentang di supplier lain
      let shouldBeChecked = false;
      if (supplierIndex === 0) {
        // Supplier pertama: centang semua item
        shouldBeChecked = true;
      } else {
        // Cek apakah item ini sudah dicentang di supplier lain
        const barangID = item["BarangID"];
        let alreadyCheckedInOtherSupplier = false;

        for (let i = 0; i < supplierIndex; i++) {
          if (allSuppliers[i] && allSuppliers[i].PRListComparison) {
            const sameItem = allSuppliers[i].PRListComparison.find(
              (otherItem) => otherItem.BarangID === barangID
            );
            if (sameItem && sameItem.PilihanBeli) {
              alreadyCheckedInOtherSupplier = true;
              break;
            }
          }
        }

        // Jika belum dicentang di supplier lain, centang di supplier ini (yang harga terendah)
        shouldBeChecked = !alreadyCheckedInOtherSupplier;
      }

      // Set PilihanBeli default
      const pilihanBeli =
        item["PilihanBeli"] !== undefined
          ? item["PilihanBeli"]
          : shouldBeChecked;

      // Hanya hitung jika item dipilih (PilihanBeli = true)
      if (pilihanBeli) {
        totalHargaChecked += totalAfterItemDiscount;
        totalItemDiscount += itemDiscount;
      }

      return {
        ...item,
        PilihanBeli: pilihanBeli,
        TotalHarga: totalAfterItemDiscount,
        TotalBeforeDiscount: totalBeforeDiscount,
        ItemDiscount: itemDiscount,
      };
    });

    // Hitung diskon global
    const globalDiscountPercent = parseFloat(
      supplierData["DiscountPercent"] || 0
    );
    const globalDiscountRupiah = parseFloat(
      supplierData["DiscountRupiah"] || 0
    );
    let globalDiscount = 0;

    if (globalDiscountPercent > 0) {
      globalDiscount = (totalHargaChecked * globalDiscountPercent) / 100;
    } else if (globalDiscountRupiah > 0) {
      globalDiscount = globalDiscountRupiah;
    }

    const totalAfterAllDiscounts = totalHargaChecked - globalDiscount;

    // Hitung pajak
    const ppn = parseFloat(supplierData["PPN"] || 0);
    const pph = parseFloat(supplierData["PPH"] || 0);
    const pbbkb = parseFloat(supplierData["PBBKB"] || 0);

    const ppnTotal = (totalAfterAllDiscounts * ppn) / 100;
    const pphTotal = (totalAfterAllDiscounts * pph) / 100;
    const pbbkbTotal = (totalAfterAllDiscounts * pbbkb) / 100;

    // Biaya Lain-lain: di LUAR biaya utama, ditambahkan setelah pajak (tak kena PPN/PPH/PBBKB).
    const biayaLain = Math.max(0, parseFloat(supplierData["BiayaLain"] || 0) || 0);

    const grandTotal =
      totalAfterAllDiscounts + ppnTotal - pphTotal + pbbkbTotal + biayaLain;

    return {
      ...supplierData,
      PRListComparison: updatedPRList,
      Total: totalHargaChecked,
      TotalItemDiscount: totalItemDiscount,
      GlobalDiscount: globalDiscount,
      Discound: globalDiscount,
      Total2: totalAfterAllDiscounts,
      PPNTotal: ppnTotal,
      PPHTotal: pphTotal,
      PBBKBTotal: pbbkbTotal,
      GTOTAL: grandTotal,
    };
  };

  useEffect(() => {
    barangDetail.mutate();
    PurchaseRequisition.mutate({ BisnisUnitID: values.BisnisUnitID });
    supplier.mutate();
    franco.mutate();

    if (param.state) {
      PriceComparison.mutate(param.state.PRComparisonID.replaceAll("/", "-"));
    }
  }, []);

  useEffect(() => {
    if (!param.state) return;
    const index = prData.findIndex(
      (x) => x.PurchaseRequisitionID === param.state.PurchaseRequisitionID
    );
    customHandler(index, "PurchaseRequisitionID");
    PurchaseRequisitionDetail.mutate(param.state.PurchaseRequisitionID.replaceAll("/", "-"));
  }, [prData]);

  useEffect(() => {
    if (mutationUpdate.isSuccess) {
      navigate("/approval-list");
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (PurchaseRequisitionDetail.data) {
      setisJasa(
        PurchaseRequisitionDetail.data.data.Tipe == "Jasa" ? true : false
      );
      setTermin1(PurchaseRequisitionDetail.data.data.Termin1);
      setTermin2(PurchaseRequisitionDetail.data.data.Termin2);
      setTermin3(PurchaseRequisitionDetail.data.data.Termin3);
      setBarang(PurchaseRequisitionDetail.data.data.PRList);
    }
  }, [PurchaseRequisitionDetail.data]);

  useEffect(() => {
    if (PriceComparison.data && barang.length > 0) {
      const tempArray = PriceComparison.data.data;
      if (tempArray && tempArray[0] && tempArray[0]["PurchaseRequisitionID"]) {
        customHandler(tempArray.length, "SupplierCount");

        // Proses supplier satu per satu dengan logika default checkbox
        const updatedArray = tempArray.map((supplier, supplierIndex) => {
          if (supplier["PRListComparison"]) {
            // Gabungkan data dari PRList dengan data yang ada di PRListComparison
            const updatedPRList = supplier["PRListComparison"].map((detail) => {
              const matchingObjectIds = getObjectIdsByPRListID(
                barang,
                detail["PRListID"]
              );

              const prListData = matchingObjectIds[0] || {};

              // Gabungkan data
              const mergedDetail = {
                ...prListData,
                ...detail,
              };

              // Pastikan Qty dari PRList asli digunakan
              if (prListData.Qty) {
                mergedDetail["Qty"] = prListData.Qty;
              }

              return mergedDetail;
            });

            // Hitung summary dengan supplier index untuk logika default checkbox
            return calculateSupplierSummary(
              {
                ...supplier,
                PRListComparison: updatedPRList,
              },
              supplierIndex,
              tempArray
            );
          }
          return supplier;
        });

        setPRListComparison(updatedArray);
      }
    }
  }, [PriceComparison.data, barang]);

  useEffect(() => {
    if (PurchaseRequisition.data && PurchaseRequisition.data.data) {
      const tempArray = PurchaseRequisition.data.data.map((datas, i) => ({
        ...datas,
        value: i,
        label: `${datas.PurchaseRequisitionID} - ${datas.Remarks}`,
      }));
      setPRData(tempArray);
    }
  }, [PurchaseRequisition.data]);

  let user = JSON.parse(localStorage.getItem("user"));

  const openFileViewer = (rawUrl) => {
    const url = rawUrl.replaceAll("/", "-");
    setFileViewer({ open: true, url: null, type: null, name: rawUrl, loading: true, error: false });

    fetch(process.env.REACT_APP_API_UPLOAD_URL + "file/" + url, { method: "GET" })
      .then((response) => {
        const contentType = response.headers.get("Content-Type") || "";
        return response.blob().then((blob) => ({ blob, contentType }));
      })
      .then(({ blob, contentType }) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const isPdf = contentType.includes("pdf") || rawUrl.toLowerCase().endsWith(".pdf");
        const isImage = contentType.includes("image") ||
          /\.(png|jpg|jpeg|gif|webp|bmp|svg)$/i.test(rawUrl);

        setFileViewer({
          open: true,
          url: blobUrl,
          type: isPdf ? "pdf" : isImage ? "image" : "pdf",
          name: rawUrl,
          loading: false,
          error: false,
        });
      })
      .catch(() => {
        setFileViewer((prev) => ({ ...prev, loading: false, error: true }));
        toast.warning("Data not Found!", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          theme: "light",
        });
      });
  };

  const closeFileViewer = () => {
    if (fileViewer.url) window.URL.revokeObjectURL(fileViewer.url);
    setFileViewer({ open: false, url: null, type: null, name: "", loading: false, error: false });
  };

  // Nama satuan diambil dari master barang yang sudah dimuat halaman ini
  // (Master/Barang/min). PRListComparison dari API tidak membawa NamaSatuan,
  // jadi tabel penawaran per-supplier di bawah ikut memakai helper ini.
  // Mengembalikan "" bila master belum termuat — angkanya tetap tampil.
  const satuanBarang = (barangID) =>
    barangDetail.data?.data?.find(({ value }) => value === barangID)
      ?.NamaSatuan || "";

  const header = [
    { name: "Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Qty", key: "Qty", modifiers: "QtySatuan" },
    { name: "SDT Date", key: "SDTDate", modifiers: "dateOnlyNew" },
    { name: "Specification", key: "Specification", modifiers: "Text" },
  ];

  const PRHandler = (value, names) => {
    customHandler(value, names);
    PurchaseRequisitionDetail.mutate(prData[value]["PurchaseRequisitionID"].replaceAll("/", "-"));
  };

  const SupplierCount = (e) => {
    changeHandler(e);
    let detailArray = [];
    if (PurchaseRequisitionDetail.data) {
      detailArray = PurchaseRequisitionDetail.data.data.PRList.map(
        (detail, i) => ({
          ...detail,
          Harga: 0,
          DiscountPercent: 0,
          DiscountRupiah: 0,
          Merk: "",
          PilihanBeli: false,
          TotalHarga: 0,
          ItemDiscount: 0,
        })
      );
    }

    if (e.target.value && e.target.value > 0) {
      let TempArray = [];
      for (let i = 1; i <= e.target.value; i++) {
        const obj = {
          TanggalKirim: new Date(),
          PPN: 0,
          PPH: 0,
          PBBKB: 0,
          PRListComparison: JSON.parse(JSON.stringify(detailArray)),
        };
        TempArray.push(obj);
      }
      if (PurchaseRequisitionDetail.data) {
        setPRListComparison(TempArray);
      }
    }
  };

  const PurchaseRequisitionDetailEditor = (supplierIndex, itemIndex, e) => {
    const tempArray = [...pRListComparison];
    const selectedSupplier = tempArray[supplierIndex];

    if (!selectedSupplier || !selectedSupplier.PRListComparison) return;

    const fieldName = e.target.name;
    let fieldValue = e.target.value;

    if (fieldName === "PilihanBeli") {
      fieldValue = e.target.checked;

      // Jika mencentang item ini, uncheck item dengan BarangID yang sama di supplier lain
      if (fieldValue) {
        const currentBarangID =
          selectedSupplier.PRListComparison[itemIndex].BarangID;

        for (let j = 0; j < tempArray.length; j++) {
          if (j !== supplierIndex) {
            const otherSupplier = tempArray[j];
            if (otherSupplier && otherSupplier.PRListComparison) {
              for (let k = 0; k < otherSupplier.PRListComparison.length; k++) {
                if (
                  otherSupplier.PRListComparison[k].BarangID === currentBarangID
                ) {
                  otherSupplier.PRListComparison[k]["PilihanBeli"] = false;
                }
              }
              // Hitung ulang summary untuk supplier lain
              tempArray[j] = calculateSupplierSummary(
                otherSupplier,
                j,
                tempArray
              );
            }
          }
        }
      }
    }

    // Update nilai field
    selectedSupplier.PRListComparison[itemIndex][fieldName] = fieldValue;

    // Hitung ulang summary untuk supplier ini
    tempArray[supplierIndex] = calculateSupplierSummary(
      selectedSupplier,
      supplierIndex,
      tempArray
    );

    setPRListComparison(tempArray);
  };

  const SupplierBuilder = () => {
    if (!values.SupplierCount || values.SupplierCount <= 0) {
      return [];
    }

    return Array.from({ length: values.SupplierCount }, (_, i) => i + 1).map(
      (supplierNumber) => (
        <li key={supplierNumber} className="mr-2" role="presentation">
          <button
            onClick={() => setSupplierSelected(supplierNumber)}
            className={`
            inline-block p-4 rounded-t-lg border-b-2 font-medium text-sm
            ${
              supplierSelected === supplierNumber
                ? "text-blue-600 border-blue-600 bg-white"
                : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300"
            }
          `}
            type="button"
            role="tab"
            aria-selected={supplierSelected === supplierNumber}
          >
            Detail Supplier - {supplierNumber}
          </button>
        </li>
      )
    );
  };

  const Kirim = (type) => {
    let newValues = [];
    if (values.SupplierCount && values.SupplierCount > 0) {
      for (let i = 0; i < values.SupplierCount; i++) {
        let obj = ChangeToString(pRListComparison[i]);
        for (let j = 0; j < obj["PRListComparison"].length; j++) {
          obj["PRListComparison"][j] = ChangeToString(
            obj["PRListComparison"][j]
          );
          obj["PRListComparison"][j]["PilihanBeli"] =
            "" +
            (obj["PRListComparison"][j]["PilihanBeli"] === true ||
              obj["PRListComparison"][j]["PilihanBeli"] === "true");
        }
        obj["PRComparisonID"] = param.state.PRComparisonID;
        obj["PurchaseRequisitionID"] = param.state.PurchaseRequisitionID;
        newValues.push(obj);
      }
    }

    mutationUpdate.mutate({
      PRCApprovalID: param.state.PRCApprovalID,
      Approved: type,
      KeteranganTolak: type === 2 ? rejectReason.trim() : "",
      PRComparisonInsert: newValues,
      PRComparisonID: param.state.PRComparisonID,
    });
  };

  // Konfirmasi Approve/Tolak: buka modal dulu, aksi baru dijalankan setelah dikonfirmasi.
  const requestAction = (type) => {
    setConfirmModal({ show: true, type: type === 1 ? "approve" : "reject" });
  };

  const confirmAction = () => {
    const isReject = confirmModal.type === "reject";
    if (isReject && !rejectReason.trim()) return; // alasan wajib saat menolak
    // Konfirmasi tambahan (alert bawaan) sebelum benar-benar menolak — aksi tak bisa dibatalkan.
    if (
      isReject &&
      !window.confirm(
        "Yakin MENOLAK Price Comparison ini? Tindakan tidak dapat dibatalkan."
      )
    ) {
      return;
    }
    setConfirmModal({ show: false, type: null });
    Kirim(isReject ? 2 : 1);
    setRejectReason("");
  };

  function prEditor(name, ids, e) {
    var temp = [...pRListComparison];
    temp[ids][name] = e;
    // Hitung ulang summary
    temp[ids] = calculateSupplierSummary(temp[ids]);
    setPRListComparison(temp);
  }

  const isLoading = mutationSave.isLoading || mutationUpdate.isLoading;
  const SpinIcon = () => (
    <svg aria-hidden="true" role="status" className="inline mr-2 w-4 h-4 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
    </svg>
  );

  // ── File Viewer Modal ──────────────────────────────────────
  const FileViewerModal = () => {
    if (!fileViewer.open) return null;
    return (
      <div className="fixed inset-0 z-50 flex flex-col bg-black bg-opacity-80">
        {/* Toolbar */}
        <div className="flex items-center justify-between px-4 py-3 bg-gray-900 text-white shrink-0">
          <div className="flex items-center gap-2 text-sm">
            {fileViewer.type === "pdf"
              ? <BiFile className="text-red-400 text-lg" />
              : <BiImage className="text-blue-400 text-lg" />}
            <span className="truncate max-w-xs opacity-80">{fileViewer.name}</span>
          </div>
          <div className="flex items-center gap-3">
            {fileViewer.url && (
              <a
                href={fileViewer.url}
                download={fileViewer.name}
                className="text-xs px-3 py-1.5 bg-white text-gray-800 rounded hover:bg-gray-200 transition-colors font-medium"
              >
                Download
              </a>
            )}
            <button
              onClick={closeFileViewer}
              className="p-1.5 rounded-full hover:bg-gray-700 transition-colors"
              aria-label="Tutup"
            >
              <BiX className="text-2xl" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 flex items-center justify-center overflow-hidden bg-gray-800">
          {fileViewer.loading && (
            <div className="flex flex-col items-center gap-3 text-white">
              <BiLoader className="text-4xl animate-spin" />
              <span className="text-sm opacity-70">Memuat file...</span>
            </div>
          )}
          {fileViewer.error && (
            <div className="text-center text-white">
              <p className="text-lg font-semibold mb-1">File tidak ditemukan</p>
              <p className="text-sm opacity-60">Pastikan file masih tersedia di server.</p>
            </div>
          )}
          {fileViewer.url && fileViewer.type === "pdf" && (
            <iframe
              src={fileViewer.url}
              title="Preview PDF"
              className="w-full h-full border-0"
              style={{ minHeight: "80vh" }}
            />
          )}
          {fileViewer.url && fileViewer.type === "image" && (
            <img
              src={fileViewer.url}
              alt="Preview"
              className="max-w-full max-h-full object-contain p-4"
              style={{ maxHeight: "calc(100vh - 56px)" }}
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="md:ml-64">
      <FileViewerModal />
      <ConfirmModal
        show={confirmModal.show}
        type={confirmModal.type}
        reason={rejectReason}
        onReasonChange={setRejectReason}
        onConfirm={confirmAction}
        onCancel={() => {
          setConfirmModal({ show: false, type: null });
          setRejectReason("");
        }}
      />
      <div style={{ background: Colors.primary }} className="pt-14 pb-16 px-3 md:px-8 h-auto">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>

      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5">

                {/* Toolbar */}
                <div className="flex flex-wrap gap-2 justify-end px-3 pb-3">
                  <button
                    onClick={() => navigate("/procurment/transaksi/price-comparison")}
                    className="flex items-center justify-center bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded transition-colors"
                  >
                    <BiArrowBack className="text-xl mr-1" />
                    Kembali
                  </button>
                  <button
                    onClick={() => requestAction(1)}
                    disabled={isLoading}
                    className="flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 border border-green-500 shadow rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isLoading ? <><SpinIcon />Loading</> : "Approve"}
                  </button>
                  <button
                    onClick={() => requestAction(2)}
                    disabled={isLoading}
                    className="flex items-center justify-center bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 border border-red-500 shadow rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isLoading ? <><SpinIcon />Loading</> : "Tolak"}
                  </button>
                </div>

                {/* Info MSR */}
                {PurchaseRequisition.data ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 px-3 mb-4">
                    <div>
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Nomor MSR</label>
                      <Select
                        value={prData.filter(({ value }) => value === values["PurchaseRequisitionID"])}
                        isDisabled={true}
                        name="PurchaseRequisitionID"
                        className="appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white"
                        onChange={(text) => PRHandler(text.value, "PurchaseRequisitionID")}
                        options={prData}
                      />
                    </div>
                    {prData[values["PurchaseRequisitionID"]] && (
                      <div>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Tanggal MSR</label>
                        <div className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white">
                          {new Date(prData[values["PurchaseRequisitionID"]]["DatePR"]).toISOString().substring(0, 10)}
                        </div>
                      </div>
                    )}
                    {prData[values["PurchaseRequisitionID"]] && (
                      <div className="sm:col-span-2 lg:col-span-1">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Keterangan</label>
                        <div className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white">
                          {prData[values["PurchaseRequisitionID"]]["Remarks"]}
                        </div>
                      </div>
                    )}
                    <div className="sm:col-span-2 lg:col-span-1">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        Term of Payment / Cash
                      </label>
                      {!adaTopTerisi ? (
                        <div className="appearance-none block w-full text-gray-500 border border-gray-200 rounded py-3 px-4 leading-tight bg-white">
                          Belum diisi
                        </div>
                      ) : isCashMode ? (
                        <div className="appearance-none block w-full border border-amber-300 bg-amber-50 rounded py-3 px-4 leading-tight">
                          <span className="font-bold text-amber-800">CASH</span>
                          <span className="block text-xs text-amber-700 mt-1">
                            Menyetujui di level terakhir akan MEMBENTUK uang muka Rp{" "}
                            <b>
                              {(
                                cashDownpaymentAmount || cashDownpaymentEstimasi
                              ).toLocaleString("in-ID", {
                                maximumFractionDigits: 0,
                              })}
                            </b>{" "}
                            secara otomatis, masuk antrean Pembayaran Non-PO.
                          </span>
                          {isCampuran && (
                            <span className="block text-xs text-amber-700 mt-1">
                              Dokumen CAMPURAN — supplier lain bertermin{" "}
                              <b>{topLabels.join(" / ")}</b>.
                            </span>
                          )}
                        </div>
                      ) : (
                        <div className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white">
                          <span className="font-bold">
                            TERM OF PAYMENT
                            {topLabels.length > 0 && (
                              <span className="font-normal"> — {topLabels.join(" / ")}</span>
                            )}
                          </span>
                          <span className="block text-xs text-gray-500 mt-1">
                            Dibayar setelah barang/jasa diterima. Tanpa uang muka.
                          </span>
                        </div>
                      )}
                    </div>

                    {isJasa && Termin1 > 0 && (
                      <div>
                        <HrdInputGenerator type="text" value={{Termin1: Termin1}} name="Termin1" title="Termin 1 (%)" onChange={() => {}} touched={touched} buttonTouched={buttonTouched} size="full" required={false} errors={errors} disabled={true} />
                      </div>
                    )}
                    {isJasa && Termin2 > 0 && (
                      <div>
                        <HrdInputGenerator type="text" value={{Termin2: Termin2}} name="Termin2" title="Termin 2 (%)" onChange={() => {}} touched={touched} buttonTouched={buttonTouched} size="full" required={false} errors={errors} disabled={true} />
                      </div>
                    )}
                    {isJasa && Termin3 > 0 && (
                      <div>
                        <HrdInputGenerator type="text" value={{Termin3: Termin3}} name="Termin3" title="Termin 3 (%)" onChange={() => {}} touched={touched} buttonTouched={buttonTouched} size="full" required={false} errors={errors} disabled={true} />
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="flex items-center gap-2 px-3 mb-4 text-gray-500 text-sm">
                    <svg aria-hidden="true" className="w-4 h-4 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                    </svg>
                    Loading data MSR...
                  </div>
                )}

                {/* Jumlah Supplier */}
                <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-3 mb-4">
                  <HrdInputGenerator type="number" value={values} name="SupplierCount" title="Jumlah Supplier" onChange={SupplierCount} touched={touched} buttonTouched={buttonTouched} size="full" required={true} errors={errors} disabled={true} />
                </div>

                <hr />

                {/* Tabel Barang PR */}
                {PurchaseRequisitionDetail.isLoading ? (
                  <Skeltons />
                ) : (
                  <div className="overflow-x-auto w-full">
                    <DynamicTableSimple data={barang} header={header} OnClick={ModalOpener} name="Purchase Requisition" barang={barangDetail.data} />
                  </div>
                )}

                <hr className="my-5" />

                {/* Tab Supplier */}
                <div className="mb-4 border-b border-gray-200">
                  <ul className="flex flex-wrap gap-1 -mb-px text-sm font-medium text-center" role="tablist">
                    {SupplierBuilder()}
                    <li key="comparison" role="presentation">
                      <button
                        onClick={() => setSupplierSelected(-1)}
                        className={`inline-block p-4 rounded-t-lg border-b-2 font-medium text-sm transition-colors ${supplierSelected === -1 ? "text-blue-600 border-blue-600 bg-white" : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300"}`}
                        type="button" role="tab"
                      >
                        Komparasi
                      </button>
                    </li>
                    <li key="toggle-detail" role="presentation">
                      <button
                        onClick={() => setshowDetail(!showDetail)}
                        className="inline-block p-4 rounded-t-lg border-b-2 bg-main-100 text-white font-medium text-sm"
                        type="button"
                      >
                        {showDetail ? "Sembunyikan" : "Tampilkan"} Supplier Data
                      </button>
                    </li>
                  </ul>

                  {PurchaseRequisitionDetail.isLoading ? (
                    <Skeltons />
                  ) : (
                    <>
                      {pRListComparison.map((cats, ids) => {
                        if (ids === supplierSelected - 1) {
                          return (
                            <div key={`Main-${ids}`} className="mt-6">
                              {showDetail && (
                                <div className="text-left">

                                  {/* Baris 1: Nama Supplier, Tanggal Quotation, No Quotation */}
                                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 px-3 mb-4">
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Nama Supplier/Vendor</label>
                                      <input type="text" disabled readOnly value={cats["NamaSupplierDisplay"] || cats["NamaSupplier"] || ""} className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white" />
                                    </div>
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Tanggal Quotation</label>
                                      <DatePicker
                                        utcOffset={0}
                                        dateFormat="dd/MMMM/yyyy"
                                        disabled={true}
                                        selected={new Date(cats["TanggalKirim"])}
                                        className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white"
                                        onChange={(text) => prEditor("TanggalKirim", ids, text)}
                                      />
                                    </div>
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">No. Quotation</label>
                                      <input
                                        type="text"
                                        disabled={true}
                                        value={cats["Quotation"]}
                                        name={"Quotation"}
                                        className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white"
                                        onChange={(e) => {
                                          prEditor(
                                            "Quotation",
                                            ids,
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                  {/* Baris 2: Franco, TOP, Mata Uang */}
                                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 px-3 mb-4">
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Franco</label>
                                      {franco.data && (
                                        <Select value={franco.data.data.filter(({ value }) => value === cats["FrancoID"])} isDisabled={true} name="FrancoID" className="appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white" onChange={(text) => prEditor("FrancoID", ids, text.value)} options={franco.data.data} />
                                      )}
                                    </div>
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Term of Payment</label>
                                      <Select value={Top.filter(({ value }) => value === cats["TOP"])} isDisabled={true} name="TOP" className="appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white" onChange={(text) => prEditor("TOP", ids, text.value)} options={Top} />
                                    </div>
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Mata Uang</label>
                                      <Select value={Currency.filter(({ value }) => value === cats["Currency"])} isDisabled={true} name="Currency" className="appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white" onChange={(text) => prEditor("Currency", ids, text.value)} options={Currency} />
                                    </div>
                                  </div>

                                  {/* Baris 3: Diskon */}
                                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-3 mb-4">
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Diskon %</label>
                                      <input disabled type="number" max={100} value={cats["DiscountPercent"]} name="DiscountPercent" className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white" onChange={(e) => prEditor("DiscountPercent", ids, e.target.value)} />
                                    </div>
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Diskon Rp</label>
                                      <input disabled type="number" value={cats["DiscountRupiah"]} name="DiscountRupiah" className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white" onChange={(e) => prEditor("DiscountRupiah", ids, e.target.value)} />
                                    </div>
                                  </div>

                                  {/* Baris 4: Pajak */}
                                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-3 mb-4">
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">PPN %</label>
                                      <input disabled type="number" max={100} value={cats["PPN"]} name="PPN" className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white" onChange={(e) => prEditor("PPN", ids, e.target.value)} />
                                    </div>
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">PPH %</label>
                                      <input disabled type="number" max={100} value={cats["PPH"]} name="PPH" className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white" onChange={(e) => prEditor("PPH", ids, e.target.value)} />
                                    </div>
                                  </div>

                                  {/* Baris 4b: Biaya Lain-lain — di luar pajak (tak kena PPN/PPH/PBBKB) */}
                                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 px-3 mb-4">
                                    <div>
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Biaya Lain-lain</label>
                                      <input disabled readOnly type="text" value={(parseFloat(cats["BiayaLain"]) || 0).toLocaleString("in-ID", { maximumFractionDigits: 0 })} name="BiayaLain" className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white" />
                                    </div>
                                    <div className="sm:col-span-2">
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Keterangan Biaya Lain-lain</label>
                                      <input disabled readOnly type="text" value={cats["KeteranganBiayaLain"] || "-"} name="KeteranganBiayaLain" className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white" />
                                    </div>
                                  </div>

                                  {/* Baris 5: TOC full width */}
                                  <div className="px-3 mb-4">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Term of Condition</label>
                                    <textarea value={cats["TOC"]} name="TOC" rows={3} className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight bg-white resize-none" onChange={(e) => prEditor("TOC", ids, e.target.value)} />
                                  </div>

                                  {/* Data pendukung */}
                                  {cats["NamaFile"] && (
                                    <div className="px-3 mb-4">
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Data Pendukung</label>
                                      <button
                                        type="button"
                                        onClick={() => openFileViewer(cats["NamaFile"])}
                                        className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors"
                                      >
                                        {/\.(png|jpg|jpeg|gif|webp|bmp|svg)$/i.test(cats["NamaFile"])
                                          ? <BiImage className="text-lg" />
                                          : <BiFile className="text-lg" />}
                                        <span className="truncate max-w-xs">{cats["NamaFile"]}</span>
                                        <span className="text-xs opacity-60 shrink-0">— klik untuk lihat</span>
                                      </button>
                                    </div>
                                  )}

                                </div>
                              )}

                              {/* Tabel Detail Barang */}
                              <div className="overflow-x-auto w-full mt-6">
                              <table className="table-auto w-full text-sm text-left text-gray-500 min-w-max">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                  <tr>
                                    <th
                                      scope="col"
                                      className="py-3 px-6"
                                      rowSpan={2}
                                    >
                                      Barang/Jasa
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3 px-6"
                                      rowSpan={2}
                                    >
                                      JUMLAH PENGAJUAN
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3 px-6"
                                      rowSpan={2}
                                    >
                                      Harga Satuan
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3 px-6 text-center border-b"
                                      colSpan={2}
                                    >
                                      Diskon Per Item
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3 px-6"
                                      rowSpan={2}
                                    >
                                      Merek/Tipe Barang
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3 px-6"
                                      rowSpan={2}
                                    >
                                      Total Harga (Qty × Harga)
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3 px-6"
                                      rowSpan={2}
                                    >
                                      Pilihan Beli
                                    </th>
                                  </tr>
                                  <tr>
                                    <th
                                      scope="col"
                                      className="py-3 px-6 text-center"
                                    >
                                      %
                                    </th>
                                    <th
                                      scope="col"
                                      className="py-3 px-6 text-center"
                                    >
                                      Rp
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {cats["PRListComparison"] &&
                                    cats["PRListComparison"].map(
                                      (detail, id) => {
                                        const classOdd =
                                          id % 2 === 0
                                            ? "bg-white border-b hover:bg-gray-50"
                                            : "bg-gray-50 border-b hover:bg-gray-100";

                                        let texts = "";
                                        if (
                                          barangDetail.data &&
                                          barangDetail.data.data
                                        ) {
                                          const val =
                                            barangDetail.data.data.filter(
                                              ({ value }) =>
                                                value === detail.BarangID
                                            );
                                          if (val[0]) {
                                            texts = val[0]["label"];
                                          }
                                        }

                                        return (
                                          <tr key={id} className={classOdd}>
                                            <th
                                              scope="row"
                                              className="py-4 px-6 font-medium whitespace-nowrap"
                                            >
                                              {texts}
                                            </th>
                                            <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                              {`${parseFloat(
                                                detail["Qty"] || 0
                                              ).toLocaleString("in-ID", {
                                                maximumFractionDigits: 2,
                                              })} ${satuanBarang(
                                                detail.BarangID
                                              )}`.trim()}
                                            </td>
                                            <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                              {parseFloat(
                                                detail["Harga"] || 0
                                              ).toLocaleString("in-ID", {
                                                maximumFractionDigits: 0,
                                              })}
                                            </td>
                                            <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                              {parseFloat(
                                                detail["DiscountPercent"] || 0
                                              ).toFixed(2)}
                                              %
                                            </td>
                                            <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                              {parseFloat(
                                                detail["DiscountRupiah"] || 0
                                              ).toLocaleString("in-ID", {
                                                maximumFractionDigits: 0,
                                              })}
                                            </td>
                                            <td className="py-4 px-6 font-medium whitespace-nowrap">
                                              {detail["Merk"] || "-"}
                                            </td>
                                            <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                              {parseFloat(
                                                detail["TotalHarga"] || 0
                                              ).toLocaleString("in-ID", {
                                                maximumFractionDigits: 0,
                                              })}
                                            </td>
                                            <td className="py-4 px-6">
                                              <input
                                                type="checkbox"
                                                checked={
                                                  detail["PilihanBeli"] || false
                                                }
                                                name="PilihanBeli"
                                                className="w-4 h-4 text-main-100 bg-gray-100 rounded border-main-100 focus:ring-main-100 focus:ring-2"
                                                onChange={(e) =>
                                                  PurchaseRequisitionDetailEditor(
                                                    ids,
                                                    id,
                                                    e
                                                  )
                                                }
                                              />
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                </tbody>
                                <tfoot>
                                  <tr className="bg-gray-50">
                                    <th
                                      scope="row"
                                      colSpan={7}
                                      className="py-4 px-6 font-medium whitespace-nowrap text-right"
                                    >
                                      Jumlah (Total Harga)
                                    </th>
                                    <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                      {parseFloat(
                                        cats["Total"] || 0
                                      ).toLocaleString("in-ID", {
                                        maximumFractionDigits: 0,
                                      })}
                                    </td>
                                  </tr>
                                  <tr className="bg-white">
                                    <th
                                      scope="row"
                                      colSpan={7}
                                      className="py-4 px-6 font-medium whitespace-nowrap text-right"
                                    >
                                      Diskon (Supplier Level)
                                    </th>
                                    <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                      {parseFloat(
                                        cats["Discound"] || 0
                                      ).toLocaleString("in-ID", {
                                        maximumFractionDigits: 0,
                                      })}
                                    </td>
                                  </tr>
                                  <tr className="bg-gray-100 font-bold">
                                    <th
                                      scope="row"
                                      colSpan={7}
                                      className="py-4 px-6 font-medium whitespace-nowrap text-right"
                                    >
                                      Jumlah Setelah Diskon
                                    </th>
                                    <td className="py-4 px-6 font-medium whitespace-nowrap text-right border-t border-gray-300">
                                      {parseFloat(
                                        cats["Total2"] || 0
                                      ).toLocaleString("in-ID", {
                                        maximumFractionDigits: 0,
                                      })}
                                    </td>
                                  </tr>
                                  {parseFloat(cats["PPNTotal"] || 0) > 0 && (
                                    <tr className="bg-white">
                                      <th
                                        scope="row"
                                        colSpan={7}
                                        className="py-4 px-6 font-medium whitespace-nowrap text-right"
                                      >
                                        PPN ({parseFloat(cats["PPN"] || 0)}%)
                                      </th>
                                      <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                        {parseFloat(
                                          cats["PPNTotal"] || 0
                                        ).toLocaleString("in-ID", {
                                          maximumFractionDigits: 0,
                                        })}
                                      </td>
                                    </tr>
                                  )}
                                  {parseFloat(cats["PPHTotal"] || 0) > 0 && (
                                    <tr className="bg-gray-50">
                                      <th
                                        scope="row"
                                        colSpan={7}
                                        className="py-4 px-6 font-medium whitespace-nowrap text-right"
                                      >
                                        PPH ({parseFloat(cats["PPH"] || 0)}%)
                                      </th>
                                      <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                        {parseFloat(
                                          cats["PPHTotal"] || 0
                                        ).toLocaleString("in-ID", {
                                          maximumFractionDigits: 0,
                                        })}
                                      </td>
                                    </tr>
                                  )}
                                  {parseFloat(cats["PBBKBTotal"] || 0) > 0 && (
                                    <tr className="bg-white">
                                      <th
                                        scope="row"
                                        colSpan={7}
                                        className="py-4 px-6 font-medium whitespace-nowrap text-right"
                                      >
                                        PBBKB ({parseFloat(cats["PBBKB"] || 0)}
                                        %)
                                      </th>
                                      <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                        {parseFloat(
                                          cats["PBBKBTotal"] || 0
                                        ).toLocaleString("in-ID", {
                                          maximumFractionDigits: 0,
                                        })}
                                      </td>
                                    </tr>
                                  )}
                                  {parseFloat(cats["BiayaLain"] || 0) > 0 && (
                                    <tr className="bg-white">
                                      <th
                                        scope="row"
                                        colSpan={7}
                                        className="py-4 px-6 font-medium whitespace-nowrap text-right"
                                      >
                                        Biaya Lain-lain
                                        {cats["KeteranganBiayaLain"] ? ` (${cats["KeteranganBiayaLain"]})` : ""}
                                      </th>
                                      <td className="py-4 px-6 font-medium whitespace-nowrap text-right">
                                        {parseFloat(cats["BiayaLain"] || 0).toLocaleString("in-ID", {
                                          maximumFractionDigits: 0,
                                        })}
                                      </td>
                                    </tr>
                                  )}
                                  <tr className="bg-blue-50 font-bold border-t-2 border-gray-400">
                                    <th
                                      scope="row"
                                      colSpan={7}
                                      className="py-4 px-6 font-medium whitespace-nowrap text-right text-blue-800"
                                    >
                                      Grand Total
                                    </th>
                                    <td className="py-4 px-6 font-medium whitespace-nowrap text-right text-lg text-blue-700 border-t-2 border-blue-400">
                                      {parseFloat(
                                        cats["GTOTAL"] || 0
                                      ).toLocaleString("in-ID", {
                                        maximumFractionDigits: 0,
                                      })}
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })}

                      {supplierSelected === -1 && pRListComparison.length > 0 && (
                        <div key="comparison-view" className="mt-6 overflow-x-auto">
                          <table className="table-auto w-full text-sm text-left text-gray-600 min-w-max">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100">
                              <tr>
                                <th className="py-3 px-4 sticky left-0 bg-gray-100 z-10">Barang/Jasa</th>
                                {pRListComparison.map((s, i) => (
                                  <th key={i} className="py-3 px-4 text-center border-l border-gray-300" colSpan={3}>
                                    {s["NamaSupplierDisplay"] || s["NamaSupplier"] || `Supplier ${i + 1}`}
                                  </th>
                                ))}
                              </tr>
                              <tr className="bg-gray-50">
                                <th className="py-2 px-4 sticky left-0 bg-gray-50 z-10"></th>
                                {pRListComparison.map((_, i) => (
                                  <React.Fragment key={i}>
                                    <th className="py-2 px-4 text-right border-l border-gray-300 text-xs">Harga Satuan</th>
                                    <th className="py-2 px-4 text-right text-xs">Total</th>
                                    <th className="py-2 px-4 text-center text-xs">Dipilih</th>
                                  </React.Fragment>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {(() => {
                                const allItems = pRListComparison[0]?.PRListComparison || [];
                                return allItems.map((item, rowIdx) => {
                                  let namaBarang = item["NamaBarang"] || "";
                                  if (!namaBarang && barangDetail.data?.data) {
                                    const found = barangDetail.data.data.find(({ value }) => value === item.BarangID);
                                    namaBarang = found?.label || item.BarangID || "-";
                                  }
                                  const rowClass = rowIdx % 2 === 0 ? "bg-white" : "bg-gray-50";
                                  return (
                                    <tr key={rowIdx} className={`${rowClass} border-b`}>
                                      <td className={`py-3 px-4 font-medium sticky left-0 z-10 ${rowClass}`}>{namaBarang}</td>
                                      {pRListComparison.map((s, sIdx) => {
                                        const d = s.PRListComparison?.[rowIdx] || {};
                                        const harga = parseFloat(d["Harga"] || 0);
                                        const total = parseFloat(d["TotalHarga"] || 0);
                                        const dipilih = d["PilihanBeli"];

                                        // Cari harga terendah antar supplier untuk baris ini
                                        const allHarga = pRListComparison
                                          .map(sup => parseFloat(sup.PRListComparison?.[rowIdx]?.["Harga"] || 0))
                                          .filter(h => h > 0);
                                        const minHarga = allHarga.length > 0 ? Math.min(...allHarga) : 0;
                                        const isCheapest = harga > 0 && harga === minHarga;

                                        return (
                                          <React.Fragment key={sIdx}>
                                            <td className={`py-3 px-4 text-right border-l border-gray-300 ${isCheapest ? "text-green-700 font-semibold" : ""}`}>
                                              {harga > 0 ? harga.toLocaleString("id-ID") : "-"}
                                            </td>
                                            <td className={`py-3 px-4 text-right ${isCheapest ? "text-green-700 font-semibold" : ""}`}>
                                              {total > 0 ? total.toLocaleString("id-ID") : "-"}
                                            </td>
                                            <td className="py-3 px-4 text-center">
                                              {dipilih ? (
                                                <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-green-100 text-green-700 font-bold text-xs">✓</span>
                                              ) : (
                                                <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-gray-100 text-gray-400 text-xs">–</span>
                                              )}
                                            </td>
                                          </React.Fragment>
                                        );
                                      })}
                                    </tr>
                                  );
                                });
                              })()}
                            </tbody>
                            <tfoot className="bg-blue-50 font-semibold text-gray-700">
                              {pRListComparison.some((s) => (parseFloat(s["BiayaLain"]) || 0) > 0) && (
                                <tr className="border-t border-gray-300 bg-white font-normal">
                                  <td className="py-3 px-4 sticky left-0 bg-white z-10">Biaya Lain-lain (di luar pajak)</td>
                                  {pRListComparison.map((s, i) => (
                                    <React.Fragment key={i}>
                                      <td className="py-3 px-4 text-right border-l border-gray-300" colSpan={2} title={s["KeteranganBiayaLain"] || ""}>
                                        {(parseFloat(s["BiayaLain"]) || 0).toLocaleString("id-ID", { maximumFractionDigits: 0 })}
                                      </td>
                                      <td className="py-3 px-4"></td>
                                    </React.Fragment>
                                  ))}
                                </tr>
                              )}
                              <tr className="border-t-2 border-gray-400">
                                <td className="py-3 px-4 sticky left-0 bg-blue-50 z-10">Grand Total</td>
                                {pRListComparison.map((s, i) => (
                                  <React.Fragment key={i}>
                                    <td className="py-3 px-4 text-right border-l border-gray-300" colSpan={2}>
                                      {parseFloat(s["GTOTAL"] || 0).toLocaleString("id-ID", { maximumFractionDigits: 0 })}
                                    </td>
                                    <td className="py-3 px-4"></td>
                                  </React.Fragment>
                                ))}
                              </tr>
                            </tfoot>
                          </table>
                          <p className="text-xs text-gray-400 mt-2 px-1">
                            <span className="text-green-700 font-semibold">Hijau</span> = harga terendah per item.
                            <span className="ml-2">✓ = item dipilih untuk dibeli.</span>
                          </p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalPurchaseComparationPage;